import { getSet } from '@sayfazkari/content';
import { useSession, useCurrentZikr } from '../../store/session';
import { ZikrCard } from './ZikrCard';
import { TasbihCounter } from './TasbihCounter';
import { ProgressRail } from './ProgressRail';
import { ru } from '../../strings/ru';
import styles from './SessionScreen.module.css';

export function SessionScreen() {
  const activeSet = useSession((s) => s.activeSet);
  const index = useSession((s) => s.index);
  const done = useSession((s) => s.done);
  const tap = useSession((s) => s.tap);
  const goNext = useSession((s) => s.goNext);
  const goPrev = useSession((s) => s.goPrev);
  const exitSession = useSession((s) => s.exitSession);
  const goToIndex = useSession((s) => s.goToIndex);
  const showTranslit = useSession((s) => s.settings.showTranslit);
  const showTranslation = useSession((s) => s.settings.showTranslation);

  const zikr = useCurrentZikr();
  if (!activeSet || !zikr) return null;

  const set = getSet(activeSet);
  const completed = set.items.map((z) => (done[z.id] ?? 0) >= z.repeat);

  return (
    <div className={styles.screen}>
      <div className={styles.top}>
        {/* Выход доступен всегда, в том числе на середине набора:
            прогресс сохраняется в store, дочитать можно позже.
            Системная кнопка «назад» Telegram делает то же самое,
            но на десктопе и в вебе её нет. */}
        <button
          className={styles.exitBtn}
          onClick={exitSession}
          aria-label={ru.session.exitHint}
        >
          <span aria-hidden="true">←</span> {ru.session.exit}
        </button>

        <ProgressRail
          total={set.items.length}
          index={index}
          completed={completed}
          onSelect={goToIndex}
        />
        <p className={styles.position}>
          {zikr.titleRu}
          <span className={styles.counter}>
            {index + 1} / {set.items.length}
          </span>
        </p>
      </div>

      {/* Отдельный скролл-контейнер: вёрстка не завязана на
          viewportHeight, который скачет во время анимации раскрытия */}
      <div className={styles.scroll} key={zikr.id}>
        <ZikrCard
          zikr={zikr}
          showTranslit={showTranslit}
          showTranslation={showTranslation}
        />
      </div>

      <div className={styles.bottom}>
        <TasbihCounter
          done={done[zikr.id] ?? 0}
          total={zikr.repeat}
          onTap={tap}
          onComplete={goNext}
        />

        <div className={styles.nav}>
          <button
            className={styles.navBtn}
            onClick={goPrev}
            disabled={index === 0}
          >
            ← Назад
          </button>
          <button className={styles.navBtn} onClick={goNext}>
            Далее →
          </button>
        </div>
      </div>
    </div>
  );
}
